import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

import type { DateRange } from '../../types/extranet-api.types';

const startOfMonth = () => {
  const d = new Date();
  d.setUTCDate(1);
  d.setUTCHours(0, 0, 0, 0);
  return d.toISOString();
};

const now = () => new Date().toISOString();

export interface GlobalFiltersState {
  entityIds: string[];
  contractIds: string[];
  siteIds: string[];
  dateRange: DateRange;
  setEntityIds: (ids: string[]) => void;
  setContractIds: (ids: string[]) => void;
  setSiteIds: (ids: string[]) => void;
  setDateRange: (range: DateRange) => void;
  reset: () => void;
}

const initialState = {
  entityIds: [],
  contractIds: [],
  siteIds: [],
  dateRange: { from: startOfMonth(), to: now() },
};

export const useFilterStore = create<GlobalFiltersState>()(
  persist(
    set => ({
      ...initialState,
      setEntityIds: ids => set({ entityIds: ids }),
      setContractIds: ids => set({ contractIds: ids }),
      setSiteIds: ids => set({ siteIds: ids }),
      setDateRange: range => set({ dateRange: range }),
      reset: () => set(initialState),
    }),
    {
      name: 'extranet:filters',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
